<template>
  <div>
    <modal-layout-top :title="title"/>
    <div class="content slider-modal">
      <!--<div class="slider-modal-fields">-->
        <!--<slot />-->
        <div class="field" v-if="displayCustomer">
          <label class="label">Kund *</label>
          <model-list-select :list="customers"
            option-value="customerId"
            optionText="name"
            v-model="address.customerId"
            placeholder="Välj kund">
          </model-list-select>
          <div v-show="errors.has('customerId')" class="invalid-feedback">{{ errors.first('customerId') }}</div>
        </div>

        <div class="field">
          <label class="label">Adresstyp</label>
          <div class="select">
            <!-- TODO: saas -->
            <select v-model="address.addressType" @change="setAddressName">
              <option value="Odefinierad">Odefinierad</option>
              <option value="Fakturaadress">Fakturaadress</option>
              <option value="Objekt">Objekt</option>
              <option value="Etablering">Etablering</option>
              <option value="Kontor">Kontor</option>
              <option value="Mötesadress">Mötesadress</option>
              <option value="Övriga">Övriga</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ getNameLabel() }}</label>
          <input class="input" type="text" v-model="address.name">
        </div>

        <div class="field">
          <label class="label">Adressrad 1 *</label>
          <input class="input" type="text" v-model="address.address1" v-validate="'required'">
        </div>

        <div class="field">
          <label class="label">Adressrad 2</label>
          <input class="input" type="text" v-model="address.address2">
        </div>

        <div class="field">
          <label class="label">Postnummer *</label>
          <input class="input" type="text" v-model="address.postalCode">
          <div v-show="errors.has('postalCode')" class="invalid-feedback">{{ errors.first('postalCode') }}</div>
        </div>

        <div class="field">
          <label class="label">Ort *</label>
          <input class="input" type="text" v-model="address.city">
          <div v-show="errors.has('city')" class="invalid-feedback">{{ errors.first('city') }}</div>
        </div>

        <div class="required-message">* obligatoriskt fält</div>
        <modal-layout-buttons :store-name="'addresses'" />
      </div>

    <!--</div>-->
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import { ModelListSelect } from 'vue-search-select'

export default {
  name: 'address-new-modal',
  data () {
    return {
      address: {
        addressId: 0,
        customerId: 0,
        name: null,
        address1: null,
        address2: null,
        postalCode: null,
        city: null,
        addressType: 'Odefinierad',
        primary: false
      },
      projectSelected: false,
      showAddToProject: false,
      customers: []
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons,
    ModelListSelect
  },
  props: {
    id: {
      type: Number,
      required: false
    },
    customerId: {
      type: Number,
      required: false
    },
    addressType: {
      type: String,
      required: false
    },
    preventListReload: {
      type: Boolean,
      default: false
    },
    displayCustomer: {
      type: Boolean,
      default: true
    },
    saveAddress: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      // projects: state => state.projects.all,
      // customers: state => state.customers.all,
      // addresses: state => state.addresses.all
    }),

    currentUser: function () {
      return JSON.parse(localStorage.getItem('user')).initials
    },

    allCustomers: function () {
      return this.customers.items
    },

    customerProjects: function () {
      return this.projects.items
    },

    title () {
      if (!this.id) {
        return 'Lägg till ny address'
      } else {
        return this.address.name ? 'Ändra address ' + this.address.name : 'Ändra address'
      }
    }
  },

  methods: {
    ...mapActions(
      'addresses', ['getById', 'update', 'create', 'createProjectAddress']
    ),

    ...mapActions({
      'getAllCustomers': 'customers/getAll'
      // 'getProjects': 'projects/getListData'
    }),
    setAddressName () {
      if (this.address.addressType === 'Fakturaadress' && !this.address.name && this.address.customerId) {
        this.address.name = this.customers.items.find(x => x.customerId === this.address.customerId).name
      }
    },
    getNameLabel () {
      switch (this.address.addressType) {
        case 'Objekt':
          return 'Objekt'
        case 'Fakturaadress':
          return 'Fakturamottagare'
        default:
          return 'Namn'
      }
    },
    closePanel () {
      this.$emit('closePanel', { response: this.address })
    },

    save () {
      if (this.address.addressType === 'null') {
        this.address.addressType = 'Odefinierad'
      }

      // Called from CustomerModal
      if (!this.saveAddress) {
        this.closePanel()
        return
      }

      if (this.id) {
        this.update(this.address).then(address => {
          this.address = address
          if (this.address.projectId) {
            let projectAddress = {
              projectId: this.address.projectId,
              addressId: this.address.addressId,
              primary: this.address.primary
            }
            this.createProjectAddress(projectAddress)
          }
          this.closePanel()
          if (!this.preventListReload) {
            this.$emit('pageChange')
          }
        })
      } else {
        this.create(this.address).then(address => {
          this.address = address
          if (this.address.projectId) {
            let projectAddress = {
              projectId: this.address.projectId,
              addressId: address.addressId,
              primary: this.address.primary
            }
            this.createProjectAddress(projectAddress)
          }

          this.closePanel()

          if (!this.preventListReload) {
            this.$emit('pageChange')
          }
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })
    setTimeout(() => {
      this.getAllCustomers().then(customers => {
        this.customers = customers
      })

      if (this.id) {
        this.getById(this.id).then(address => {
          this.address = address.result
        })
      } else {
        this.address.addressType = 'Odefinierad'
      }

      if (this.addressType) {
        this.address.addressType = this.addressType
      } else {
        this.address.addressType = 'Odefinierad'
      }

      // From project panel
      if (this.customerId) {
        this.address.customerId = this.customerId
      }
    }, 300)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/AddressModal.vue